import userBucketedInExperiment from '../utils/experiments';

const consentHandler = (consentType, wrapper, form) => {
  const explicitValue = '1';
  const wrapperData = wrapper.dataset;
  const b2bExplicitContentLabel = wrapperData.b2bExplicitConsent;
  const b2bImplicitContentLabel = wrapperData.b2bImplicitConsent;
  const consentLabelId = wrapper.elements[1].id;
  const consentWrapper = wrapper.querySelector('.js-form-check');
  const consentCheckbox = wrapper.querySelector('[type="checkbox"]');
  const consentCheckboxesValues = wrapper.getElementsByClassName('collection_check_boxes');
  const consentCheckboxesDivs = wrapper.getElementsByClassName('form-check js-form-check');
  const consentRadiobutton = wrapper.getElementsByClassName('js-consent-radiobutton');
  const consentLabel = wrapper.querySelector(`[for="${consentLabelId}"]`);

  const { consentRadiobuttonEnabled, programLanguage } = wrapperData;
  const consentLabelRadiobutton = wrapper.querySelector('legend');

  const forMyself = form.elements.myself == null
    || b2bExplicitContentLabel === undefined
    || form.elements.myself.checked;

  let inquiringRadioButton;

  const explicitContentLabel = () => {
    if (userBucketedInExperiment('e20231226_granular_consent:variant')) {
      return wrapperData.consentGranularLabel;
    }

    return wrapperData.explicitConsent;
  };

  const implicitContentLabel = () => {
    if (userBucketedInExperiment('e20231226_granular_consent:variant')) {
      return wrapperData.consentGranularLabel;
    }

    return wrapperData.implicitConsent;
  };

  if (form.id === 'group-enrollment-modal-form') {
    inquiringRadioButton = 'team';
  } else if (forMyself && consentLabelId !== 'group_enrollments_interested_form_agree') {
    inquiringRadioButton = 'myself';
  } else {
    inquiringRadioButton = 'team';
  }

  if (consentRadiobuttonEnabled === 'true') {
    for (let k = 0; k < consentCheckboxesDivs.length; k += 1) {
      consentCheckboxesDivs[k].classList.add('input-inline');

      if (programLanguage !== 'es') {
        consentCheckboxesDivs[k].classList.add('width-49');
      }
    }

    if (consentType === explicitValue) {
      for (let k = 0; k < consentCheckboxesValues.length; k += 1) {
        consentCheckboxesValues[k].classList.remove('hidden');
      }
      for (let k = 0; k < consentRadiobutton.length; k += 1) {
        consentRadiobutton[k].classList.remove('hidden');
      }

      if (inquiringRadioButton === 'myself') {
        consentLabelRadiobutton.innerHTML = explicitContentLabel();
      } else {
        consentLabelRadiobutton.innerHTML = b2bExplicitContentLabel;
      }
    } else {
      for (let k = 0; k < consentCheckboxesValues.length; k += 1) {
        consentCheckboxesValues[k].classList.add('hidden');
      }
      for (let k = 0; k < consentRadiobutton.length; k += 1) {
        consentRadiobutton[k].classList.add('hidden');
      }

      if (inquiringRadioButton === 'myself') {
        consentLabelRadiobutton.innerHTML = implicitContentLabel();
      } else {
        consentLabelRadiobutton.innerHTML = b2bImplicitContentLabel;
      }
    }
  } else if (consentType === explicitValue) {
    consentCheckbox.checked = false;
    consentCheckbox.classList.remove('hidden');
    consentWrapper.classList.remove('form-check--hide-checkbox');

    if (inquiringRadioButton === 'myself') {
      consentLabel.innerHTML = explicitContentLabel();
    } else {
      consentLabel.innerHTML = b2bExplicitContentLabel;
    }
  } else {
    consentCheckbox.classList.add('hidden');
    consentWrapper.classList.add('form-check--hide-checkbox');

    if (inquiringRadioButton === 'myself') {
      consentLabel.innerHTML = implicitContentLabel();
    } else {
      consentLabel.innerHTML = b2bImplicitContentLabel;
    }
  }
};

const changeCountryHandler = (e) => {
  const { form } = e.target;
  const countrySelect = form.querySelector('.js-custom-form [type="country"]');
  const wrapper = form.querySelector('.js-custom-form__contact-checkbox-block');
  const wrapperData = wrapper.dataset;
  const gdprCountries = wrapperData.gdprCountries.split(' ');
  const nonGdprMoreCautiousCountries = wrapperData.nonGdprMoreCautiousCountries.split(' ');
  const {
    gdprType,
    nonGdprMoreCautiousType,
    nonGdprLessCautiousType,
    programLanguage,
  } = wrapperData;
  const countryCode = countrySelect.value;
  const implicitValue = '2';
  const consentCheckbox = wrapper.querySelector('[type="checkbox"]');

  if (countryCode === 'BR' && programLanguage === 'pt') {
    consentHandler(implicitValue, wrapper, form);
    consentCheckbox.checked = true;
  } else if (gdprCountries.includes(countryCode)) {
    consentHandler(gdprType, wrapper, form);
  } else if (nonGdprMoreCautiousCountries.includes(countryCode)) {
    consentHandler(nonGdprMoreCautiousType, wrapper, form);
  } else {
    consentHandler(nonGdprLessCautiousType, wrapper, form);
  }
};

export default changeCountryHandler;
